import React, { Fragment } from "react";
import { defineMessages, injectIntl } from "react-intl";
import { Dialog, Label } from "cci-component";
import { localize } from "cci-utility";
import BusinessSelectionList from "./SelectionList";

const messages = defineMessages({
  businesses: {
    id: "Businesses",
    defaultMessage: "Businesses"
  },
  changeBusinessSelect: {
    id: "changeBusinessSelect",
    defaultMessage: "Select the business where the user will be"
  }
});

/**
 * Modal dialog to with list of businesses to select from.
 * 
 * Props:
 * - onSelected: Function that is called when the user taps one of the businesses in the list.
 * - change: Boolean,true for change business of selected user (userId) or switch business instead.
 * - userId: UUID on string, User identifier to change business.
 */
const SelectionDialog = props => (
  <Dialog
    title={messages.businesses}
    width={.5}
    height={.5}
    {...props}
  >
    <Fragment>
      {props.change && (
        <Label margins="10px 0">
          {localize(props.intl, messages.changeBusinessSelect)}
        </Label>
      )}
      <BusinessSelectionList
        onSelected={props.onSelected}
        style={{flex: 1}}
        change={props.change}
        userId={props.userId}
      />
    </Fragment>
  </Dialog>
);

export default injectIntl(SelectionDialog);
